import React from "react";
// import BatchActions from "../recce/BatchActions";
import JobsActionPanel from "../recce/RecceAllTabs";

export default function RecceTable({
  openModalToCreateJobBatches,
  setOpenModalToCreateJobBatches,
}) {
  return (
    <div>
      <JobsActionPanel
        openModalToCreateJobBatches={openModalToCreateJobBatches}
        setOpenModalToCreateJobBatches={setOpenModalToCreateJobBatches}
      />
      {/* <div
          style={{
            boxShadow: "0 0 4px rgba(0.5, 0.5, 0.5, 0.5)",
            backgroundColor: "#ffffff",
            borderRadius: "1rem",
            border: "1px solid #d9dadb",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            overflow: "auto",
          }}
        >
          <div
            style={{
              height: "300px",
              overflowY: "auto",
            }}
          >
            <style>
              {`
      div::-webkit-scrollbar {
        display: none; 
      }
    `}
            </style>
            <div>
              <Box sx={{ padding: "1rem" }}>
                <BatchAccordion />
              </Box>
            </div>
          </div>

          <BatchActions />
        </div> */}
    </div>
  );
}
